;(function () {

  // Ajax routes need the market root, or Shopify answers in the default market. routes.root ends in '/'.
  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'
  }
  const mainProduct = document.querySelector('[data-main-product]')
  if (!mainProduct) return
  const stickyBar = mainProduct.querySelector('[data-sticky-atb]')
  if (!stickyBar) return

  const addToCartBtn = mainProduct.querySelector('[data-add-to-cart]')
  const notifySubmit = mainProduct.querySelector('[data-notify-submit]')
  const ctaArea = mainProduct.querySelector('[data-cta-area]')
  const stickySubmit = stickyBar.querySelector('[data-sticky-atb-submit]')
  const mainSizeOptions = mainProduct.querySelector('[data-size-options]')
  const mainColourSwatches = mainProduct.querySelector('[data-colour-swatches]')
  const mainDenominationOptions = mainProduct.querySelector('[data-denomination-options]')
  const stickySizeOptions = stickyBar.querySelector('[data-sticky-size-options]')
  const errorEl = stickyBar.querySelector('[data-sticky-atb-error]')

  // The whole bar hides only when every variant is sold out; a single out-of-stock
  // variant just disables the Add to Bag pill.
  const productSoldOut = stickyBar.getAttribute('data-product-available') === 'false'

  // ── Show / hide ──────────────────────────────────────────────
  function showStickyBar() {
    stickyBar.setAttribute('data-sticky-atb-visible', '')
    stickyBar.removeAttribute('aria-hidden')
    stickyBar.removeAttribute('inert')
  }

  function hideStickyBar() {
    stickyBar.removeAttribute('data-sticky-atb-visible')
    stickyBar.setAttribute('aria-hidden', 'true')
    stickyBar.setAttribute('inert', '')
  }

  // ── Published height ─────────────────────────────────────────
  // --height-sticky-atb lets overlays size around the bar. Measured, not tokenised: the
  // height is content-driven (price row, wrapped title).
  function publishStickyHeight() {
    document.documentElement.style.setProperty('--height-sticky-atb', stickyBar.offsetHeight + 'px')
  }

  publishStickyHeight()
  if (window.ResizeObserver) new ResizeObserver(publishStickyHeight).observe(stickyBar)

  // ── Add-to-bag pill state: disable while the selected variant is out of stock ─
  // The pill is an action-pill, so aria-disabled gives it the shared disabled look;
  // picking an in-stock size re-enables it. Left alone while the "Choose Size" gate
  // owns the pill — that state is never aria-disabled so it stays clickable.
  function currentVariantUnavailable() {
    return !!ctaArea && ctaArea.classList.contains('hidden')
  }

  function syncStickyAddState() {
    if (!stickySubmit) return
    if (currentVariantUnavailable()) {
      stickySubmit.setAttribute('aria-disabled', 'true')
    } else if (!stickySubmit.hasAttribute('data-atb-needs-size')) {
      stickySubmit.removeAttribute('aria-disabled')
    }
  }

  // ── Show / hide ──────────────────────────────────────────────
  let footerVisible = false
  let actionOutOfView = false
  let zoomOpen = document.documentElement.hasAttribute('data-zoom-open')

  function refreshStickyBar() {
    // The overlay covers the buy area without removing it, so the observers below would hold the
    // bar hidden — and hidden here means inert, not merely out of sight.
    if (zoomOpen && !productSoldOut) {
      showStickyBar()
      return
    }
    // Hidden only when the product is sold out in every size, at the footer, or
    // while the buy-area action is still on screen. A single out-of-stock size
    // keeps the bar (and its size picker) so the shopper can switch sizes.
    if (productSoldOut || footerVisible || !actionOutOfView) {
      hideStickyBar()
    } else {
      showStickyBar()
    }
  }

  // Add to Bag, Notify Me, the notify confirmation, and every buy-box option picker (colour, size,
  // gift-card denomination) swap in and out of the buy area, so watch all anchors and treat the
  // action as on screen while any one is visible. The confirmation counts: it replaces the notify
  // submit once a shopper subscribes, and the buy area is still in front of them. The option pickers
  // are included so the sticky bar never appears while the shopper can still see and use any of the
  // buy box's own controls (e.g. a tall buy box on first load, before any scroll, where the CTA sits
  // below the fold but a picker further up — colour, size, or denomination — is still on screen).
  const notifySuccess = mainProduct.querySelector('[data-notify-success]')
  const actionAnchors = [
    addToCartBtn,
    notifySubmit,
    notifySuccess,
    mainColourSwatches,
    mainSizeOptions,
    mainDenominationOptions,
  ].filter(Boolean)
  // On desktop the bar never shows on the first fold: every anchor must have scrolled up past the top of
  // the viewport, not merely be off screen, so a buy box whose controls start below the fold keeps it
  // hidden until the shopper has scrolled beyond them (confirmed by Vin, TASK-54942). Mobile keeps the
  // off-screen-either-way rule, where the buy box sits under the gallery. A display:none anchor measures
  // bottom 0, so it counts as passed and never holds the bar back.
  const desktopQuery = window.matchMedia(
    `(min-width: ${getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-lg').trim() || '1024px'})`
  )
  if (actionAnchors.length) {
    const anchorInView = new Map()
    const updateActionOutOfView = () => {
      actionOutOfView = desktopQuery.matches
        ? actionAnchors.every((el) => el.getBoundingClientRect().bottom <= 0)
        : ![...anchorInView.values()].some(Boolean)
      refreshStickyBar()
    }
    const actionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => anchorInView.set(entry.target, entry.isIntersecting))
      updateActionOutOfView()
    })
    actionAnchors.forEach((el) => actionObserver.observe(el))
    desktopQuery.addEventListener('change', updateActionOutOfView)
  }

  // ── Zoom guard: the overlay publishes its state on <html> ────
  new MutationObserver(() => {
    zoomOpen = document.documentElement.hasAttribute('data-zoom-open')
    refreshStickyBar()
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['data-zoom-open'] })

  // ── Footer guard: hide the bar once the footer is reached ────
  const footer = document.querySelector('[data-footer]')
  if (footer) {
    new IntersectionObserver(([entry]) => {
      footerVisible = entry.isIntersecting
      refreshStickyBar()
    }).observe(footer)
  }

  // ── Variant guard: re-evaluate the pill state and visibility when the buy area
  // swaps between Add to Bag and Notify Me ─────────────────────
  if (ctaArea) {
    new MutationObserver(() => {
      syncStickyAddState()
      refreshStickyBar()
    }).observe(ctaArea, { attributes: true, attributeFilter: ['class'] })
  }
  syncStickyAddState()

  // ── Size sync ────────────────────────────────────────────────
  function syncStickySize(sizeName) {
    if (!stickySizeOptions) return
    stickySizeOptions.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.checked = radio.value === sizeName
    })
  }

  if (mainSizeOptions && stickySizeOptions) {
    const initMainRadio = mainSizeOptions.querySelector('input[type="radio"]:checked')
    if (initMainRadio) syncStickySize(initMainRadio.value)

    mainSizeOptions.addEventListener('change', (e) => {
      const radio = e.target.closest('input[type="radio"]')
      if (radio) syncStickySize(radio.value)
    })

    stickySizeOptions.addEventListener('change', (e) => {
      const radio = e.target.closest('input[type="radio"]')
      if (!radio) return
      const mainRadio = mainSizeOptions.querySelector(
        `input[type="radio"][value="${CSS.escape(radio.value)}"]`
      )
      if (!mainRadio) return
      mainRadio.checked = true
      mainRadio.dispatchEvent(new Event('change', { bubbles: true }))
    })

    // An out-of-stock size in the sticky bar routes to the Notify Me form. Bound to click (not change) so a
    // click on the already-selected size still fires; deferred so the notify form is shown (by the change
    // handler above) before scrollToNotify scrolls and focuses.
    stickySizeOptions.addEventListener('click', (e) => {
      const sizeLabel = e.target.closest('label.action-size[aria-disabled="true"]')
      if (!sizeLabel) return
      requestAnimationFrame(function () {
        if (window.broraProduct && window.broraProduct.scrollToNotify) window.broraProduct.scrollToNotify()
      })
    })
  }

  // ── ATB submission ───────────────────────────────────────────
  if (stickySubmit) {
    stickySubmit.addEventListener('click', async () => {
      // Out-of-stock size selected → the pill is disabled, nothing to add. The
      // "Choose Size" gate below is never aria-disabled, so it still falls through.
      if (stickySubmit.getAttribute('aria-disabled') === 'true') return

      // "Choose Size" state — no size selected yet, so never add. Take the shopper to
      // the size picker in the PDP instead. main-product.js clears the flag
      // (and swaps the label) on the first size selection.
      if (stickySubmit.hasAttribute('data-atb-needs-size')) {
        if (mainSizeOptions) {
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
          mainSizeOptions.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' })
          // The scroll brings [data-size-options] into view, which now hides (and inerts) this bar via
          // the widened observer — move focus to the picker first, or the browser resets it to <body>
          // once inert lands on stickySubmit's subtree. Mirrors main-product.js's scrollToNotify().
          const firstSize =
            mainSizeOptions.querySelector('input[type="radio"]:checked') ||
            mainSizeOptions.querySelector('input[type="radio"]:not(:disabled)') ||
            mainSizeOptions.querySelector('input[type="radio"]')
          if (firstSize) firstSize.focus({ preventScroll: true })
        }
        return
      }

      const variantId = mainProduct.querySelector('[data-variant-id]')?.value
      if (!variantId) return

      stickySubmit.disabled = true
      stickySubmit.setAttribute('aria-disabled', 'true')
      if (errorEl) {
        errorEl.textContent = ''
        errorEl.classList.add('hidden')
      }

      const controller = new AbortController()
      const timeout = setTimeout(() => controller.abort(), 8000)

      try {
        // Submit the product form (FormData) so app-injected line-item properties[...] and extra
        // items[...] (e.g. the Wrapped gift product + gift message) ride along — a hardcoded
        // { id, quantity } body would drop them. Mirrors the main PDP add-to-cart handler.
        const form = mainProduct.querySelector('[data-product-form]')
        const res = await fetch(shopRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: form ? new FormData(form) : new URLSearchParams({ id: variantId, quantity: '1' }),
          signal: controller.signal,
        })

        if (!res.ok) {
          const body = await res.json().catch(() => ({}))
          throw new Error(body.description || 'Could not add to bag')
        }

        // Notify Elevate of the add (the sticky bar adds via the mini-bag API, not
        // the cart:added seam, so it notifies imperatively). Voyado data/ticket
        // logic lives in voyado-product-page.js.
        if (window.VoyadoProductPage) window.VoyadoProductPage.notifyAddToCart()

        // Pass the added line item and the displayed compare-at price so the notification renders the price
        // and compare instantly.
        const addedResp = await res.json().catch(() => null)
        const addedItem = addedResp && (addedResp.items ? addedResp.items[0] : addedResp)
        const cmpEl = mainProduct.querySelector('[data-pdp-compare]')
        const compareText = cmpEl ? cmpEl.innerHTML.trim() : null
        mainProduct.dispatchEvent(new CustomEvent('cart:added', {
          bubbles: true,
          detail: { item: addedItem, compareText, variantId: String(variantId) },
        }))
      } catch (err) {
        if (errorEl) {
          // Revealed before the text is written: a live region inside display:none is outside the
          // accessibility tree, so a change made while hidden is never announced.
          errorEl.classList.remove('hidden')
          errorEl.textContent = err.name === 'AbortError'
            ? 'Request timed out. Please try again.'
            : (err.message || 'Something went wrong. Please try again.')
        }
      } finally {
        clearTimeout(timeout)
        stickySubmit.disabled = false
        stickySubmit.removeAttribute('aria-disabled')
      }
    })
  }
})()
